webpackJsonp([273169441309362],{

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/services_juvederm.261dd03b.jpg";

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(23);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _services_juvederm = __webpack_require__(609);
	
	var _services_juvederm2 = _interopRequireDefault(_services_juvederm);
	
	var _ShareButtons = __webpack_require__(31);
	
	var _ShareButtons2 = _interopRequireDefault(_ShareButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageMeta = {
	  title: "Juvederm Fillers",
	  desc: '"Juvederm facial fillers are hyaluronic acid injectable treatments that reduce lines and wrinkles and provide lift by restoring volume."'
	};
	var AboutPage = function AboutPage(_ref) {
	  var transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style, className: 'page' },
	    _react2.default.createElement(_PageHeader2.default, { bgPhoto: _services_juvederm2.default, contain: true, styles: { backgroundColor: "#e9e9e9" } }),
	    typeof window !== 'undefined' && _react2.default.createElement(_ShareButtons2.default, { location: location.href, desc: pageMeta.desc }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'title-bar' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          pageMeta.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          pageMeta.desc
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The effects can last up to 24 months.  They are optimally used in combination with Botox treatments.'
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-juvederm-fillers-js-ed13ebb968deb588ade3.js